import React from 'react'
import { Link } from 'react-router-dom'
// TODO move ui
// import { Text } from '@brainstud/schiphol-vtc-ui'
import { replaceData } from '@brainstud/react-helpers'
import Intro from '../Intro'
import Help from '../../shared/quizhelp'

const Quiz = props => (
  <Intro
    title="Oefen Toets"
    side={
      <div>
        <Text lead style={{ paddingRight: '6rem' }}>{replaceData(props.quiz.info, { chapter: props.chapter.prefix })}</Text>
        <Help.quiz {...props} />
      </div>
    }
    main={
      <div>
        <Text>Na afloop van de oefentoets krijg je jouw score te zien. Je kunt dan ook terug naar alle vragen en antwoorden, om te bekijken wat er (minder) goed ging.</Text>
        <Text>Wil je deze oefentoets overslaan? Ga dan naar het <Link to={props.nextTo}>volgende hoofdstuk</Link>.</Text>
      </div>
    } />
)

export default Quiz
